module.exports = __webpack_public_path__ + "img/home-2.b866c18a.png";